export default __webpack_public_path__ + "static/media/ion_open-outline_hovered.4f87ef7e.svg";